import { type JobFileImage } from './jobImages.models';

export interface JobImagesState {
  ids: string[];
  entities: Record<string, JobFileImage>;
  currentJobId: string | null;
  loadedJobIds: string[];
  isLoading: boolean;
  isLoaded: boolean;
  isAttaching: boolean;
  error: string | null;
}

type Action =
  | { type: 'FETCH_JOB_IMAGES'; payload: { jobId: string } }
  | {
      type: 'FETCH_JOB_IMAGES_SUCCESS';
      payload: { jobId: string; images: JobFileImage[] };
    }
  | { type: 'FETCH_JOB_IMAGES_FAILURE'; payload: { error: string } }
  | { type: 'ATTACH_JOB_IMAGES' }
  | { type: 'ATTACH_JOB_IMAGES_SUCCESS' }
  | { type: 'ATTACH_JOB_IMAGES_FAILURE'; payload: { error: string } }
  | {
      type: 'SET_LOADING_STATE';
      payload: { isLoading: boolean; isLoaded: boolean };
    };

export const initialState: JobImagesState = {
  ids: [],
  entities: {},
  currentJobId: null,
  loadedJobIds: [],
  isLoading: false,
  isLoaded: false,
  isAttaching: false,
  error: null,
};

export const jobImagesReducer = (
  state: JobImagesState,
  action: Action
): JobImagesState => {
  switch (action.type) {
    case 'FETCH_JOB_IMAGES':
      return {
        ...state,
        isLoading: true,
        isLoaded: state.loadedJobIds.includes(action.payload.jobId),
        currentJobId: action.payload.jobId,
        error: null,
      };

    case 'FETCH_JOB_IMAGES_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        loadedJobIds: [
          ...new Set([...state.loadedJobIds, action.payload.jobId]),
        ],
        ids: [
          ...new Set([
            ...state.ids,
            ...action.payload.images.map((img) => img.jobFileId),
          ]),
        ],
        entities: action.payload.images.reduce(
          (acc, curr) => {
            acc[curr.jobFileId] = curr;
            return acc;
          },
          { ...state.entities }
        ),
      };

    case 'FETCH_JOB_IMAGES_FAILURE':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload.error,
      };

    case 'ATTACH_JOB_IMAGES':
      return {
        ...state,
        isAttaching: true,
        error: null,
      };

    case 'ATTACH_JOB_IMAGES_SUCCESS':
      return {
        ...state,
        isAttaching: false,
      };

    case 'ATTACH_JOB_IMAGES_FAILURE':
      return {
        ...state,
        isAttaching: false,
        error: action.payload.error,
      };

    case 'SET_LOADING_STATE':
      return { ...state, ...action.payload };

    default:
      return state;
  }
};
